export default "__VITE_ASSET__93cf5dbf__"